<template>
  <div :class="$style.wrapper">
    <div v-if="!disabled" :class="[$style.label, labelClass]">
      <Icon name="check" />

      <Typography>
        {{ $i18n(articleGender === FEMININE ? 'Recommandée' : 'Recommandé') }}
      </Typography>
    </div>

    <div :class="$style.content">
      <slot />
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api'

import { FEMININE } from '@front/common/constants'
import { Icon, Typography } from '@front/ui'

export default defineComponent({
  components: { Icon, Typography },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    labelClass: {
      type: String,
      default: '',
    },
    articleGender: {
      type: String,
      default: FEMININE,
    },
  },
  setup() {
    return { FEMININE }
  },
})
</script>

<style lang="scss" module>
.wrapper {
  position: relative;
}

.label {
  position: absolute;
  top: -35px;
  left: 0px;
  display: flex;
  align-items: flex-start;
  gap: $ds-spacing-2xs;
  background-color: $ds-color-blue-dark;
  padding-left: $ds-spacing-xs;
  padding-right: $ds-spacing-xs;
  padding-top: $ds-spacing-2xs;
  padding-bottom: $ds-spacing-md;
  border-radius: $ds-radius-xs;
  width: fit-content;
  z-index: 1;
}

.content {
  position: relative;
  z-index: 2;
}
</style>
